import { API_ADDRESS } from "../../constants";
import { Inject, Injectable } from "@angular/core";

import { Purchase, PurchaseVisanet } from "../../models/purchase.model";
import { DbTable } from './DbTable';
import { HttpClient } from '@angular/common/http';


export class DbPurchases 
extends DbTable<Purchase> {

    constructor(public _http: HttpClient, public controllerPath:string)  {

        super(_http, controllerPath);

    }
  
}

export class DbPurchasesVisanet 
extends DbTable<PurchaseVisanet> {

    constructor(public _http: HttpClient, public controllerPath:string)  {

        super(_http, controllerPath);

    }
  
}


